import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./BooknowInfo.css";

const BooknowInfo = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const packageName = location.state?.title || "ZikRme Dream Vacation";

  const [formData, setFormData] = useState({
    date: "",
    days: "",
    adults: "",
    children: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Allow only numbers for numeric fields
    if (name === "days" || name === "adults" || name === "children") {
      if (!/^[0-9]*$/.test(value)) return;
    }

    setFormData({
      ...formData,
      [name]: value,
    });

    // Remove error when typing
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const validateForm = () => {
    let newErrors = {};

    if (!formData.date) {
      newErrors.date = "Date is required";
    }

    if (!formData.days) {
      newErrors.days = "Days is required";
    }

    if (!formData.adults) {
      newErrors.adults = "Adults is required";
    }

    if (formData.children === "") {
      newErrors.children = "Children is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (validateForm()) {
      navigate("/guest-details", {
        state: {
          packageName: packageName,
          date: formData.date,
          amount: "23600",
        },
      });
    }
  };

  return (
    <div className="trip-container">
      <div className="trip-card">
        <h2 className="trip-heading">
          <span className="trip-bar"></span>
          Trip Summary
        </h2>

        <label className="trip-label">Selected Package</label>
        <div className="trip-package-box">{packageName}</div>

        <div className="trip-row">
          <div className="trip-field">
            <label>Date</label>
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
            />
            {errors.date && <p className="error">{errors.date}</p>}
          </div>

          <div className="trip-field">
            <label>Days</label>
            <input
              type="text"
              name="days"
              value={formData.days}
              onChange={handleChange}
            />
            {errors.days && <p className="error">{errors.days}</p>}
          </div>
        </div>

        <div className="trip-row">
          <div className="trip-field">
            <label>Adults</label>
            <input
              type="text"
              name="adults"
              value={formData.adults}
              onChange={handleChange}
            />
            {errors.adults && <p className="error">{errors.adults}</p>}
          </div>

          <div className="trip-field">
            <label>Children</label>
            <input
              type="text"
              name="children"
              value={formData.children}
              onChange={handleChange}
            />
            {errors.children && <p className="error">{errors.children}</p>}
          </div>
        </div>

        <div className="fare-box">
          <div className="fare-row">
            <span>Base Fare:</span>
            <span>₹20,000</span>
          </div>

          <div className="fare-row">
            <span>Taxes:</span>
            <span>₹3,600</span>
          </div>

          <hr />

          <div className="fare-total">
            <span>Total:</span>
            <span>₹23,600</span>
          </div>
        </div>
        <div className="cancellation-policy-box">
          <h3>Cancellation Policy</h3>
          <b> Fully Refundable / Non-Refundable</b>
          <p>
            If you cancel before{" "}
                   [date], you get
            100% refund. Post that, 50% charge applies.
          </p>
        </div>
        <button className="next-btn" onClick={handleNext}>
          Next: Guest Details
        </button>
      </div>
    </div>
  );
};

export default BooknowInfo;
